import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminSponsor from "../../components/AdminSponsor/AdminSponsor";
import AdminSponsorView from "../../components/AdminSponsor/AdminSponsorView";

const AdminSponsors = () => {
  return (
    <div className="h-full w-full">
      <Routes>
        <Route path="sponsor" element={<AdminSponsor />} />
        <Route path="sponsor/view/:sponsorId" element={<AdminSponsorView />} />
      </Routes>
    </div>
  );
};

export default AdminSponsors;
